import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import compact from 'lodash/compact';
import QS from 'qs';
import { uuidV4, cancelRequests } from '@adsk/docs-http-client';
import Base from './base';
import { EntityItem, FolderItem } from '../models';
import { CANCEL_KEYS } from '../utils/consts';

/**
 * `Service` The search service
 */
var Search = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function Search(sdk) {
    var _this;
    _classCallCheck(this, Search);
    _this = _callSuper(this, Search, [sdk]);
    _this.sessionId = uuidV4();
    return _this;
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(Search, _Base);
  return _createClass(Search, [{
    key: "cancelSearch",
    value:
    /**
     * Cancel pending search request.
     * Also may handled by the caller by access the instance property.
     */
    function cancelSearch() {
      var tokens = compact([this.proxySearchCancelToken, this.proxySearchDeletedCancelToken, this.proxyCategoriesCancelToken]);
      tokens.length && cancelRequests(tokens);
      this.proxySearchCancelToken = undefined;
      this.proxySearchDeletedCancelToken = undefined;
      this.proxyCategoriesCancelToken = undefined;
    }

    /**
     * Search document through CP proxy api
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Search.yaml/paths/~1projects~1%7BprojectId%7D~1entities:search/post
     *
     * @param projectId -  The project uuid.
     * @param payload - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise that shape of \{
     *                                              folders: [\{ urn \}],
     *                                              documents: [\{ urn \}],
     *                                              pagination: \{ totalPages, pageSize, pageNumber \}
     *                                            \}
     */
  }, {
    key: "proxySearch",
    value: (function () {
      var _proxySearch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, payload, config) {
        var _this2 = this;
        var conf, url, _yield$this$HttpServi, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this2.proxySearchCancelToken;
                },
                setter: function setter(token) {
                  return _this2.proxySearchCancelToken = token;
                },
                clearer: function clearer() {
                  return _this2.proxySearchCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/entities:search");
              _context.next = 4;
              return this.HttpService.dmV3.postWithRetry(url, payload, conf);
            case 4:
              _yield$this$HttpServi = _context.sent;
              data = _yield$this$HttpServi.data;
              return _context.abrupt("return", {
                folders: data.folders.map(FolderItem.parseV3),
                documents: data.documents.map(EntityItem.parseV3),
                pagination: data.pagination
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function proxySearch(_x, _x2, _x3) {
        return _proxySearch.apply(this, arguments);
      }
      return proxySearch;
    }()
    /**
     * Search deleted document through CP proxy api
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Search.yaml/paths/~1projects~1%7BprojectId%7D~1entities:search-deleted/post
     *
     * @param projectId -  The project uuid.
     * @param payload - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise that shape of \{
     *                                              folders: [\{ urn \}],
     *                                              documents: [\{ urn \}],
     *                                              pagination: \{ totalPages, pageSize, pageNumber \}
     *                                            \}
     */
    )
  }, {
    key: "searchDeletedEntities",
    value: (function () {
      var _searchDeletedEntities = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, payload, config) {
        var _this3 = this;
        var conf, url, _yield$this$HttpServi2, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this3.proxySearchDeletedCancelToken;
                },
                setter: function setter(token) {
                  return _this3.proxySearchDeletedCancelToken = token;
                },
                clearer: function clearer() {
                  return _this3.proxySearchDeletedCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/entities:search-deleted");
              _context2.next = 4;
              return this.HttpService.dmV3.postWithRetry(url, payload, conf);
            case 4:
              _yield$this$HttpServi2 = _context2.sent;
              data = _yield$this$HttpServi2.data;
              return _context2.abrupt("return", {
                folders: data.folders.map(FolderItem.parseV3),
                documents: data.documents.map(EntityItem.parseV3),
                pagination: data.pagination
              });
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function searchDeletedEntities(_x4, _x5, _x6) {
        return _searchDeletedEntities.apply(this, arguments);
      }
      return searchDeletedEntities;
    }()
    /**
     * Get search categories through CP proxy api
     * https://platform.stoplight.autodesk.com/docs/docs-cp/5f3f59ee5239d-private-get-categories-from-forge-search-to-filter-documents-and-folders
     *
     * @param projectId -  The project uuid.
     * @param folderUrn -  The folder urn.
     * @param payload - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise that shape of \{
     *                                              categories: [\{ name, dataType, values: [\{ value, count \}] \}],
     *                                              pagination: \{ total, number, offset \}
     *                                            \}
     */
    )
  }, {
    key: "proxyCategories",
    value: (function () {
      var _proxyCategories = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId, folderUrn, payload, config) {
        var _this4 = this;
        var conf, url, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this4.proxyCategoriesCancelToken;
                },
                setter: function setter(token) {
                  return _this4.proxyCategoriesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this4.proxyCategoriesCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/folders/").concat(folderUrn, "/categories:query");
              _context3.next = 4;
              return this.HttpService.dmV3.postWithRetry(url, payload, conf);
            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function proxyCategories(_x7, _x8, _x9, _x10) {
        return _proxyCategories.apply(this, arguments);
      }
      return proxyCategories;
    }()
    /**
     * Get search categories through CP proxy api
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Search.yaml/paths/~1projects~1%7BprojectId%7D~1search~1categories:query/post
     *
     * @param projectId -  The project uuid.
     * @param payload - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise that shape of \{
     *                                              results: [\{ name, dataType, values: [\{ value, count \}] \}]
     *                                           \}
     */
    )
  }, {
    key: "proxyProjectCategories",
    value: (function () {
      var _proxyProjectCategories = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(projectId, payload, config) {
        var _this5 = this;
        var conf, url, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this5.proxyProjectCategoriesCancelToken;
                },
                setter: function setter(token) {
                  return _this5.proxyProjectCategoriesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this5.proxyProjectCategoriesCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/search/categories:query");
              _context4.next = 4;
              return this.HttpService.dmV3.postWithRetry(url, payload, conf);
            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function proxyProjectCategories(_x11, _x12, _x13) {
        return _proxyProjectCategories.apply(this, arguments);
      }
      return proxyProjectCategories;
    }()
    /**
     * Get search user settings
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Search.yaml/paths/~1projects~1%7BprojectId%7D~1search~1settings/get
     *
     * @param projectId -  The project uuid.
     * @param params - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight.
     */
    )
  }, {
    key: "getUserSettings",
    value: (function () {
      var _getUserSettings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(projectId, params, config) {
        var _this6 = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this6.getUserSettingsCancelToken;
                },
                setter: function setter(token) {
                  return _this6.getUserSettingsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this6.getUserSettingsCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/search/settings").concat(query);
              _context5.next = 5;
              return this.HttpService.dmV3.get(url, conf);
            case 5:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getUserSettings(_x14, _x15, _x16) {
        return _getUserSettings.apply(this, arguments);
      }
      return getUserSettings;
    }()
    /**
     * Create search user settings
     * https://platform.stoplight.autodesk.com/docs/docs-cp/eb4fcf959b6d0-create-user-search-setting
     *
     * @param projectId -  The project uuid.
     * @param payload - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight.
     */
    )
  }, {
    key: "createUserSettings",
    value: (function () {
      var _createUserSettings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(projectId, payload, config) {
        var _this7 = this;
        var conf, url, response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this7.createUserSettingsCancelToken;
                },
                setter: function setter(token) {
                  return _this7.createUserSettingsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this7.createUserSettingsCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/search/settings");
              _context6.next = 4;
              return this.HttpService.dmV3.post(url, payload, conf);
            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function createUserSettings(_x17, _x18, _x19) {
        return _createUserSettings.apply(this, arguments);
      }
      return createUserSettings;
    }()
    /**
     * Update search user settings
     * https://platform.stoplight.autodesk.com/docs/docs-cp/dbcde3d46bac4-update-user-search-setting
     *
     * @param projectId -  The project uuid.
     * @param id -  The user setting uuid.
     * @param payload - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight.
     */
    )
  }, {
    key: "updateUserSettings",
    value: (function () {
      var _updateUserSettings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(projectId, id, payload, config) {
        var _this8 = this;
        var conf, url, response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this8.updateUserSettingsCancelToken;
                },
                setter: function setter(token) {
                  return _this8.updateUserSettingsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this8.updateUserSettingsCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/search/settings/").concat(id);
              _context7.next = 4;
              return this.HttpService.dmV3.patch(url, payload, conf);
            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function updateUserSettings(_x20, _x21, _x22, _x23) {
        return _updateUserSettings.apply(this, arguments);
      }
      return updateUserSettings;
    }()
    /**
     * Get user saved queries
     * https://platform.stoplight.autodesk.com/docs/docs-cp/e2b7237503a05-get-user-related-queries
     *
     * @param projectId -  The project uuid.
     * @param params - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight.
     */
    )
  }, {
    key: "getUserQueries",
    value: (function () {
      var _getUserQueries = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(projectId, params, config) {
        var _this9 = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this9.getUserQueriesCancelToken;
                },
                setter: function setter(token) {
                  return _this9.getUserQueriesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this9.getUserQueriesCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/search/user-queries").concat(query);
              _context8.next = 5;
              return this.HttpService.dmV3.get(url, conf);
            case 5:
              response = _context8.sent;
              return _context8.abrupt("return", response.data);
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getUserQueries(_x24, _x25, _x26) {
        return _getUserQueries.apply(this, arguments);
      }
      return getUserQueries;
    }()
    /**
     * Get user saved query with given id
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Search.yaml/paths/~1projects~1%7BprojectId%7D~1search~1user-queries~1%7BqueryId%7D/get
     *
     * @param projectId -  The project uuid.
     * @param id -  The user query uuid.
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight.
     */
    )
  }, {
    key: "getUserQuery",
    value: (function () {
      var _getUserQuery = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(projectId, id, config) {
        var _this10 = this;
        var conf, url, response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this10.getUserQueryCancelToken;
                },
                setter: function setter(token) {
                  return _this10.getUserQueryCancelToken = token;
                },
                clearer: function clearer() {
                  return _this10.getUserQueryCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/search/user-queries/").concat(id);
              _context9.next = 4;
              return this.HttpService.dmV3.get(url, conf);
            case 4:
              response = _context9.sent;
              return _context9.abrupt("return", response.data);
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getUserQuery(_x27, _x28, _x29) {
        return _getUserQuery.apply(this, arguments);
      }
      return getUserQuery;
    }()
    /**
     * Create a new search
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Search.yaml/paths/~1projects~1%7BprojectId%7D~1search~1user-queries/post
     *
     * @param projectId -  The project uuid.
     * @param payload - The request parameters refer to stoplight.
     * @param params - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight.
     */
    )
  }, {
    key: "createUserQuery",
    value: (function () {
      var _createUserQuery = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(projectId, payload, params, config) {
        var _this11 = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this11.createUserQueryCancelToken;
                },
                setter: function setter(token) {
                  return _this11.createUserQueryCancelToken = token;
                },
                clearer: function clearer() {
                  return _this11.createUserQueryCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/search/user-queries").concat(query);
              _context10.next = 5;
              return this.HttpService.dmV3.post(url, payload, conf);
            case 5:
              response = _context10.sent;
              return _context10.abrupt("return", response.data);
            case 7:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function createUserQuery(_x30, _x31, _x32, _x33) {
        return _createUserQuery.apply(this, arguments);
      }
      return createUserQuery;
    }()
    /**
     * Update user query
     * https://platform.stoplight.autodesk.com/docs/docs-cp/7a7e5e3840cf5-update-query-context
     *
     * @param projectId -  The project uuid.
     * @param id -  The user query uuid.
     * @param params - The request parameters refer to stoplight.
     * @param payload - The request payload refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight.
     */
    )
  }, {
    key: "updateUserQuery",
    value: (function () {
      var _updateUserQuery = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(projectId, id, params, payload, config) {
        var _this12 = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this12.updateUserQueryCancelToken;
                },
                setter: function setter(token) {
                  return _this12.updateUserQueryCancelToken = token;
                },
                clearer: function clearer() {
                  return _this12.updateUserQueryCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/search/user-queries/").concat(id).concat(query);
              _context11.next = 5;
              return this.HttpService.dmV3.patch(url, payload, conf);
            case 5:
              response = _context11.sent;
              return _context11.abrupt("return", response.data);
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function updateUserQuery(_x34, _x35, _x36, _x37, _x38) {
        return _updateUserQuery.apply(this, arguments);
      }
      return updateUserQuery;
    }()
    /**
     * Delete user query with given id
     * https://platform.stoplight.autodesk.com/docs/docs-cp/fb01472cef84c-delete-user-query-by-id
     *
     * @param projectId -  The project uuid.
     * @param id -  The user query uuid.
     * @param params - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight.
     */
    )
  }, {
    key: "deleteUserQuery",
    value: (function () {
      var _deleteUserQuery = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(projectId, id, params, config) {
        var _this13 = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this13.deleteUserQueryCancelToken;
                },
                setter: function setter(token) {
                  return _this13.deleteUserQueryCancelToken = token;
                },
                clearer: function clearer() {
                  return _this13.deleteUserQueryCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/search/user-queries/").concat(id).concat(query);
              _context12.next = 5;
              return this.HttpService.dmV3["delete"](url, conf);
            case 5:
              response = _context12.sent;
              return _context12.abrupt("return", response.data);
            case 7:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function deleteUserQuery(_x39, _x40, _x41, _x42) {
        return _deleteUserQuery.apply(this, arguments);
      }
      return deleteUserQuery;
    }()
    /**
     * Query content inside a given version file through text content indexing of Forge Search Service
     * https://platform.stoplight.autodesk.com/docs/docs-cp/d59f56971fd1f-query-content-inside-a-given-version-file
     *
     * @remarks
     *
     * Usage example:
     *  - https://wiki.autodesk.com/pages/viewpage.action?spaceKey=a3s&title=In-viewer+text+search+specification
     *  - https://wiki.autodesk.com/pages/viewpage.action?spaceKey=a3s&title=Initiative+-+In-viewer+text+search+for+2D+documents
     *
     * @param projectId -  The project uuid.
     * @param payload - The request parameters refer to stoplight. With the following structure:
     *                         \{
     *                            "query": "FLOOR 001",
     *                            "filters": \{ "versionUrns": ["urn:adsk.wipqa:fs.file:vf.BhVzf220TauFSvLLPiA7gQ?version=1"] \},
     *                            "pageNumber": 1
     *                            "pageSize": 10
     *                         \}
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight. With the following structure:
     *                \{  status: 200 / 202, data: \{ results: [], pagination: \{\} \}
     */
    )
  }, {
    key: "searchTextContent",
    value: (function () {
      var _searchTextContent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(projectId, payload, config) {
        var _this14 = this;
        var conf, url, _yield$this$HttpServi3, data, status;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this14.searchTextContentCancelToken;
                },
                setter: function setter(token) {
                  return _this14.searchTextContentCancelToken = token;
                },
                clearer: function clearer() {
                  return _this14.searchTextContentCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/search/content-index:search");
              _context13.next = 4;
              return this.HttpService.dmV3.postWithRetry(url, payload, conf);
            case 4:
              _yield$this$HttpServi3 = _context13.sent;
              data = _yield$this$HttpServi3.data;
              status = _yield$this$HttpServi3.status;
              return _context13.abrupt("return", {
                data: data || {},
                status: status
              });
            case 8:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function searchTextContent(_x43, _x44, _x45) {
        return _searchTextContent.apply(this, arguments);
      }
      return searchTextContent;
    }()
    /**
     * Trigger content indexing for a given version file through text content indexing of Forge Search Service
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Search.yaml/paths/~1projects~1%7BprojectId%7D~1search~1content-index/post
     *
     * @remarks
     *
     * Usage example:
     *  - https://wiki.autodesk.com/pages/viewpage.action?spaceKey=a3s&title=In-viewer+text+search+specification
     *  - https://wiki.autodesk.com/pages/viewpage.action?spaceKey=a3s&title=Initiative+-+In-viewer+text+search+for+2D+documents
     *
     * @param projectId -  The project uuid.
     * @param payload - The request parameters refer to stoplight. With the following structure:
     *                         \{
     *                           versionUrn: "urn:adsk.wipqa:fs.file:vf.BhVzf220TauFSvLLPiA7gQ?version=1"
     *                         \}
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight. With the shape of \{ "id": "uuid string" \}
     */
    )
  }, {
    key: "indexTextContent",
    value: (function () {
      var _indexTextContent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(projectId, payload, config) {
        var _this15 = this;
        var conf, url, response;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this15.indexTextContentCancelToken;
                },
                setter: function setter(token) {
                  return _this15.indexTextContentCancelToken = token;
                },
                clearer: function clearer() {
                  return _this15.indexTextContentCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/search/content-index");
              _context14.next = 4;
              return this.HttpService.dmV3.post(url, payload, conf);
            case 4:
              response = _context14.sent;
              return _context14.abrupt("return", response.data);
            case 6:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function indexTextContent(_x46, _x47, _x48) {
        return _indexTextContent.apply(this, arguments);
      }
      return indexTextContent;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Search';
    }
  }]);
}(Base);
export default Search;